<template>
  <div class="relative">
    <button
      @click="toggleMenu"
      v-on-click-outside="() => (isMenuOpen = false)"
      data-cy="more-menu-button"
      class="flex h-9 w-9 cursor-pointer items-center justify-center rounded border hover:bg-blue-50"
    >
      <icon-base
        icon="vertical-dots"
        height="24"
        width="24"
        :icon-color="UTIL_COLORS.DEFAULT"
      />
    </button>
    <div
      v-if="isMenuOpen"
      class="moreButtonList absolute -bottom-1 right-0 w-max translate-y-full transform cursor-pointer overflow-hidden rounded bg-white shadow-lg"
    >
      <slot />
    </div>
  </div>
</template>
<script setup lang="ts">
import { ref } from "vue";
import { UTIL_COLORS } from "@/helpers/constants";

const isMenuOpen = ref(false);

const toggleMenu = () => {
  isMenuOpen.value = !isMenuOpen.value;
};
</script>

<style lang="postcss">
.moreButtonList li {
  @apply max-w-xs truncate whitespace-nowrap p-2 hover:bg-gray-100;
}
</style>
